module.exports = __webpack_public_path__ + "static/media/systemGenerated.22462ca1.svg";